import { format } from 'date-fns'
import React from 'react'
import {
  formatTimezoneToString,
  mapTimezoneToCustomizedTimezone,
} from 'shared-constants'
import { DATA_TEST_CLASS } from 'shared-constants/build/testIds'
import { Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { TIME_FORMAT_WITH_PERIOD, MONTH_DAY_YEAR } from 'constants/datetime'
import { COLOR_INTENT, FONT_SIZE, SPACE } from 'Theme'

interface SessionDateProps {
  startDateObject?: Date
  endDateObject?: Date
  timezone?: string
}

export const SessionDate: React.FC<SessionDateProps> = ({
  startDateObject,
  endDateObject,
  timezone,
}) => (
  <Flex
    flexDirection="column"
    gap={SPACE.PX_5}
    data-snapshot-hidden
    data-test-class={DATA_TEST_CLASS.CLIENT_SESSION_DATE}
  >
    <Text fontSize={FONT_SIZE.PX_16}>
      {format(startDateObject, MONTH_DAY_YEAR)}
    </Text>
    <Text color={COLOR_INTENT.SESSION_DATE.TEXT}>
      {`
  ${format(startDateObject, TIME_FORMAT_WITH_PERIOD)} -
  ${format(endDateObject, TIME_FORMAT_WITH_PERIOD)}`}
    </Text>
    {timezone && (
      <Text color={COLOR_INTENT.SESSION_DATE.TEXT}>
        {formatTimezoneToString(
          timezone ??
            mapTimezoneToCustomizedTimezone(
              Intl.DateTimeFormat().resolvedOptions().timeZone
            )
        )}
      </Text>
    )}
  </Flex>
)
